<template>
  <div class="training">
    <div class="module-container">
      <br>
      <h4 class="text-left"><a href="#" class="admin-clickable" @click.prevent="addModule"><strong>Add Module</strong></a></h4>
      <div class="headers row text-center">
        <div class="col-sm-3">Name</div>
        <div class="col-sm-3">Description</div>
        <div class="col-sm-3">Points</div>
        <div class="col-sm-3">Video Url</div>
      </div>
      <div
        class="module-item row clickable blue-outline text-center"
        v-for="(training, index) in program.loyaltyProgramTrainings" :key="index"
        @click="editModal(index)"
        >
        <div class="col-sm-3">{{ training.moduleName }}</div>
        <div class="col-sm-3">{{ training.description }}</div>
        <div class="col-sm-3">{{ training.points }}</div>
        <div class="col-sm-3">{{ training.videoUrl }}</div>
      </div>
    </div>
    <training-modal
      :editTrainingModule="editTrainingModule"
      :currentModuleIndex="currentModuleIndex"
      :program="program"
      :isNew="createModal"
      v-on:close="closeModal"
      ></training-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TrainingModal from './TrainingModal'

export default {
  name: 'TrainingContent',
  components: {
    'training-modal': TrainingModal
  },
  data () {
    return {
      editTrainingModule: false,
      currentModuleIndex: null,
      createModal: false
    }
  },
  computed: {
    ...mapState('loyaltyProgram', [
      'program'
    ])
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      updateProgram: 'UPDATE_PROGRAM'
    }),
    addModule () {
      const copy = this.program.loyaltyProgramTrainings.slice()
      copy.push({ questions: [] })
      this.updateProgram({ prop: 'loyaltyProgramTrainings', value: copy })
      this.currentModuleIndex = copy.length - 1
      this.createModal = true
      this.editTrainingModule = true
    },
    editModal (index) {
      this.currentModuleIndex = index
      this.editTrainingModule = true
    },
    closeModal () {
      this.currentModuleIndex = null
      this.editTrainingModule = false
      this.createModal = false
    }
  }
}
</script>

<style scoped>
.module-item {
  overflow-wrap: break-word;
}
</style>
